import { motion } from "framer-motion";

const REVEAL_INITIAL = { opacity: 0, y: 32 };
const REVEAL_INVIEW = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, margin: "-80px" };

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={REVEAL_INITIAL}
    whileInView={REVEAL_INVIEW}
    viewport={REVEAL_VIEWPORT}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
